export default "<div class=\"not_found_data\">\n  <ion-text color=\"danger\">\n    <h5>{{ text }}</h5>\n  </ion-text>\n</div>\n";